import { Request } from 'crono-fe-common/types/request';
import { ZohoSettings } from 'crono-fe-common/types/zohoSettings';
import client from 'utils/clients/client';
import { ENDPOINTS } from 'config/endpoints';

export type ZohoVerifyIntegrationResult = {
  data: { isSuccess: boolean; data?: ZohoSettings | null };
};

class ZohoService {
  private _alreadyRunningVerifyZohoIntegrationCall: Promise<ZohoVerifyIntegrationResult> | null =
    null;

  public async verifyZohoIntegration(): Promise<ZohoVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyZohoIntegrationCall) {
      return await this._alreadyRunningVerifyZohoIntegrationCall;
    } else {
      this._alreadyRunningVerifyZohoIntegrationCall =
        this._verifyZohoIntegration();
      try {
        const verifyResult =
          await this._alreadyRunningVerifyZohoIntegrationCall;
        return verifyResult;
      } catch {
        return {
          data: {
            isSuccess: false,
          },
        };
      } finally {
        this._alreadyRunningVerifyZohoIntegrationCall = null;
      }
    }
  }

  private async _verifyZohoIntegration(): Promise<ZohoVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.zoho.verify,
      config: {
        method: 'get',
      },
    };

    const result = await client(request);
    return result as ZohoVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new ZohoService();
